import { $query } from "./index.js";
// import { debounce } from "lodash";

const inputFocusFn = function (event) {
  if (event.target.matches?.('.opc-input-selectable input.zm-input__inner')) {
    setTimeout(() => {
      event.target.select?.();
    }, 100);
  }
};

const injectCssThemeVar = function() {
  if(!$query.cssTheme) return;
  const style = document.createElement('style');
  style.type = 'text/css';
  const cssContent = `
    :root{
      --theme-color: ${decodeURIComponent($query.cssTheme)};
    }
  `;
  style.innerHTML = cssContent;
  document.head.appendChild(style);
}

/*
const avoidOverlapping = debounce(function(){
  if(!document.body.getBoundingClientRect) return;
  const bot = document.querySelector("#livesdk__campaign .livesdk__invitation");
  const botRect = bot.getBoundingClientRect();
  const button = document.querySelector(".opc-layout__action__inner")
  const buttonRect = button.getBoundingClientRect();
  const notOverLapping = (botRect.y + botRect.height < buttonRect.y) || (botRect.y > buttonRect.y + buttonRect.height)
  if(!notOverLapping){
    bot.classList.add("chat-bot__move-up")
  }else{
    bot.classList.remove("chat-bot__move-up")
    document.dispatchEvent(new Event('scroll'))
  };
}, 300, {leading: false, trailing: true})
*/

export default {
  install() {
    if (this.$context.is.mobile) {
      document.addEventListener('focus', inputFocusFn, true);
      // document.addEventListener('scroll', avoidOverlapping);
    }

    injectCssThemeVar();
    
  },
  uninstall() {
    document.removeEventListener('focus', inputFocusFn, true);
    // document.removeEventListener('scroll', avoidOverlapping);
  },
};
